import React from 'react';
import {MemoryRouter as MR,BrowserRouter as BR, useLocation,matchRoutes } from 'react-router-dom';

import Load,{Lazy} from 'components/load';
import {Full} from 'components/container';
import {FallbackPage} from 'components/fallback';
import Global from 'style';

import Website  from 'components/index';
// const pattern = /\/(\w+)\/*/;

// const getAppName=(url)=>{  
//   const match = pattern.exec(url);  
//   return  match && match[1];
// };

const App = ({}) => {  
  
  const location = useLocation();  
  
  return (
      <Full>
        <Load payload={location} promise={async()=>null} fallback={FallbackPage}>
          <Website />
        </Load>
      </Full>    
  );
};

export const MemoryRouter =  ({ url }) => (
  <MR initialEntries={[url ||"/"]}>          
    <Global/>
    <App />
  </MR>
);

export const BrowserRouter = ({ url }) => (
  <BR initialEntries={[url ||"/"]}>
    <Global/>
    <App />
  </BR>
);


